import React from 'react';

import classes from './ShowLoader.module.css';
import { IsStringEmpty } from '../../utilities/CommonMethods';

const showLoader = (props) => {
    let classList = [classes.Loader];
    if (props.transparentBg) classList.push(classes.TransparentBg)
    if (props.grayBg) classList.push(classes.GrayBg)

    const renderView = props.isLoading ?
        <div className={classList.join(' ')} style={!IsStringEmpty(props.zIndex) ? { zIndex: props.zIndex } : {}} >

            <svg width="51px" height="50px" viewBox="0 0 51 50">
                <rect y="0" width="13" height="50" fill="#0096ff">
                    <animate attributeName="height" values="50;10;50" begin="0s" dur="1s" repeatCount="indefinite" />
                    <animate attributeName="y" values="00;20;00" begin="0s" dur="1s" repeatCount="indefinite" />
                </rect>
                <rect x="19" y="0" width="13" height="50" fill="#0072ff">
                    <animate attributeName="height" values="50;10;50" begin="0.2s" dur="1s" repeatCount="indefinite" />
                    <animate attributeName="y" values="00;20;00" begin="0.2s" dur="1s" repeatCount="indefinite" />
                </rect>
                <rect x="38" y="0" width="13" height="50" fill="#0048ff">
                    <animate attributeName="height" values="50;10;50" begin="0.4s" dur="1s" repeatCount="indefinite" />
                    <animate attributeName="y" values="00;20;00" begin="0.4s" dur="1s" repeatCount="indefinite" />
                </rect>
            </svg>

            {props.showMessage ? <p>Please wait <br /> Your application is being submitted</p> : null}
        </div>
        : null;
    return renderView;
}

export default showLoader;